import React from 'react'
import Counting from '../../pages/Counting/Counting'
import Scroll from '../../pages/Scroll/Scroll'
import Footer from '../../pages/Footer/Footer'
import WeCare from '../../pages/WeCare/WeCare'
import Service from '../../pages/Service/Service'
import Info from '../../pages/Info/Info'
import Partner from '../../pages/Partner/Partner'
import HomeSlider from '../../pages/Slider/HomeSlider'
import CreateForm from '../../pages/Form/CreateForm'
import Testimonial from '../../pages/Testimonial/Testimonial'

const Home = () => {
  return (
    <>
      <HomeSlider/>
      <Counting/>
      <WeCare/>
      <Service/>
      <Testimonial/>
      <Info/>
      <Partner/>
      <CreateForm/>
      <Scroll/>
      <Footer/>
    </>
  )
}

export default Home
